import React from "react";
import "../styles/AboutUs.css";

function AboutUs() {
  return (
    <section id="about" className="about-section">
      <div className="section-container about-container">
        {/* Left side: text */}
        <div className="about-text">
          <h2>About Us</h2>
          <p>
            <b>NYAYOM LEGAL SERVICES</b> is a Mumbai-based boutique law firm offering client-focused and solution-oriented legal services in Intellectual Property, Estate Planning & Advisory. Founded by <b>Adv. Divyesh Devendra Waghela</b>, B.Sc.Biochemistry, MBA, LL.B.
          </p>
          <p>
            The name NYAYOM is a purposeful amalgamation of two Sanskrit words deeply rooted in Hindu philosophy: NYAYA and OM.
          </p>
          <div className="about-text-explain">
            <ul>
              <li>
                NYAYA represents the Rule of Law, grounded in natural logic and systematic reasoning.
              </li>
              <li>
                OM is the primordial, imperishable sound of the universe—the source from which all things arise.
              </li>
            </ul>
          </div>
          <p>
            At NYAYOM, we embody this philosophy—becoming the voice of our clients to represent their best interests, much like the eternal resonance of OM.
          </p>
        </div>

        {/* Right side: image */}
        <div className="about-image">
          <img src="/AboutUs.jpg" alt="About Nyayom Legal Services" />
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
